// Opens a print-friendly window with the given title + HTML body and triggers
// the browser print dialog. Used for IMS report actions (Print Directions,
// Print Tag/Sign, Print Estimate / Russ Version, invoices, etc.).
//
// `extraCss` lets report builders (see lib/reports.ts) append the faithful
// ActiveReports-style layout CSS. Printing waits for any <img> to finish
// loading so estimate/invoice picture pages render before the dialog opens.
export function printHtml(title: string, bodyHtml: string, extraCss = '') {
  const w = window.open('', '_blank', 'width=850,height=1000')
  if (!w) { alert('Please allow pop-ups to print.'); return }
  w.document.write(`<!doctype html><html><head><title>${title}</title>
    <meta charset="utf-8"/>
    <style>
      * { box-sizing: border-box; }
      body { font-family: Arial, Helvetica, sans-serif; color: #111; margin: 32px; }
      h1,h2,h3 { margin: 0 0 8px; }
      h2 { font-size: 20px; }
      h3 { font-size: 15px; color: #333; }
      hr { border: none; border-top: 1px solid #ccc; margin: 16px 0; }
      table { width: 100%; border-collapse: collapse; margin: 8px 0 16px; font-size: 13px; }
      th, td { text-align: left; padding: 6px 8px; border-bottom: 1px solid #ddd; }
      th { background: #f3f4f6; }
      .right { text-align: right; }
      .totals td { border: none; padding: 2px 8px; }
      .totals .label { color: #555; }
      .tag { border: 2px solid #111; border-radius: 8px; padding: 16px; width: 320px; }
      .tag .price { font-size: 28px; font-weight: bold; }
      @media print { body { margin: 0; } .noprint { display: none; } }
      ${extraCss}
    </style></head><body>${bodyHtml}
    <script>
      window.onload = function () {
        var imgs = document.images, n = imgs.length, done = 0;
        function go() { try { window.focus(); } catch (e) {} window.print(); }
        if (n === 0) { go(); return; }
        var timer = setTimeout(go, 4000);
        function tick() { if (++done >= n) { clearTimeout(timer); go(); } }
        for (var i = 0; i < n; i++) {
          var im = imgs[i];
          if (im.complete) tick();
          else { im.onload = tick; im.onerror = tick; }
        }
      };
    </script>
    </body></html>`)
  w.document.close()
}
